import { Component, EventEmitter, Input, Output, TemplateRef } from '@angular/core';
import { CalendarCustomer, CalendarDay, CalendarFlorderInfo } from 'app/core/store/calendar/common/calendar.interface';
import moment from 'moment';
import { CdkDragDrop } from '@angular/cdk/drag-drop';

@Component({
  selector: 'app-calendar-day',
  templateUrl: './calendar-day.component.html',
  styleUrls: ['./calendar-day.component.scss'],
  // changeDetection: ChangeDetectionStrategy.OnPush,
})
export class CalendarDayComponent {
  @Input() day: CalendarDay;
  @Input() selectedDay: moment.Moment;
  @Input() customers: CalendarCustomer[];

  @Input() tooltipRef: TemplateRef<any>;

  @Output() showFlorderModal = new EventEmitter<CalendarDay>();
  @Output() openFlorder = new EventEmitter<CalendarFlorderInfo>();

  getMonthAbbreviation() {
    return this.day.date.format('MMM');
  }
}
